import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setEmail('');
  };
  return <section className="bg-[#1d1d1f] py-24 md:py-32 px-6 relative overflow-hidden" id="contact" data-id="element-159">
      {/* Texture Overlay */}
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-160" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-162">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-163">
            Stay Connected
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-white mb-6" data-id="element-164">
            Join Our Exclusive List
          </h2>
          <p className="text-[#86868b] text-[18px] md:text-[20px] mb-12 font-light max-w-2xl mx-auto" data-id="element-165">
            Subscribe for new openings, VIP events, and exclusive offers
            delivered to your inbox.
          </p>
        </motion.div>

        <motion.form initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto" data-id="element-166">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email address" className="flex-1 px-8 py-4 bg-white/5 border border-white/10 text-white placeholder-[#86868b] focus:outline-none focus:border-[#c9a961] transition-colors duration-300 rounded-sm" aria-label="Email Address" required data-id="element-167" />
          <button type="submit" className="px-10 py-4 bg-[#c9a961] text-black font-medium text-[14px] uppercase tracking-wide hover:bg-[#d4b872] transition-colors duration-300 min-w-[160px] rounded-sm" data-id="element-168">
            Subscribe
          </button>
        </motion.form>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-[#86868b] text-[13px] mt-8 font-light" data-id="element-169">
          By subscribing, you agree to our Privacy Policy. No spam, ever.
        </motion.p>
      </div>
    </section>;
}